import React, { Fragment } from 'react';
import { Field } from 'formik';
import CheckboxGroup from './controls/CheckboxGroup';

const CheckboxList = ({ name, onChange, onBlur, ...props }) => {
  return (
    <Field
      name={name}
      render={({ field, form: { setFieldValue } }) => (
        <Fragment>
          <CheckboxGroup
            {...props}
            name={field.name}
            onChange={setFieldValue}
            selected={field.value}
            items={props.options} />
        </Fragment>
      )}
    />
  );
}

export default CheckboxList;



// WEBPACK FOOTER //
// ./src/components/form/CheckboxList.js